import { render, staticRenderFns } from "./TopTipsters.vue?vue&type=template&id=3d37c35a&"
import script from "./TopTipsters.vue?vue&type=script&lang=js&"
export * from "./TopTipsters.vue?vue&type=script&lang=js&"
import style0 from "./TopTipsters.vue?vue&type=style&index=0&id=3d37c35a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports